import { Component, HostListener, OnInit } from '@angular/core';

import { Platform } from '@ionic/angular';

import { FieldType } from '@ngx-formly/core';
import { AuditService } from '@services/audit.service';

const TAG = 'TaRangeComponent';

@Component({
    selector: 'app-ta-range',
    templateUrl: 'ta-range.html',
    styleUrls: ['ta-range.scss'],
    standalone: false
})
export class TaRangeComponent extends FieldType implements OnInit {

    public debounceTime = 10;
    public disableClear = false;
    private updatedKey: string;

    constructor(
        private platform: Platform,
        private auditService: AuditService
    ) {
        super();
    }

    @HostListener('ionChange')
    public ionChange() {
        this.rangeChanges();

    }

    ngOnInit() {
        this.updatedKey = this.key as string;
        if (this.field.parent?.key && this.field.parent?.parent.key) {
            this.updatedKey = this.field.parent?.parent.key + '[' + this.field.parent?.key + '].' + this.key;
        }

        if (this.platform.is('ios')) {
            this.debounceTime = 30;
        }
    }

    public clear() {
        // The formControl.reset triggers an ionChange event with a null formControl.value
        this.formControl.reset(null);
    }

    private rangeChanges() {
        if (!isNaN(parseFloat(this.formControl.value))) {
            this.disableClear = false;
            this.auditService.setLocationAndTimestamp(this.updatedKey);
        } else {
            this.disableClear = true;
            this.auditService.unsetLocationAndTimestamp(this.updatedKey);
        }
    }

}
